import React from "react";

import { faHandshake } from "@fortawesome/pro-solid-svg-icons/faHandshake";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Company, Deal, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import EntityLink from "../EntityLink";

import styles from "./DealName.module.scss";
import useEntityClickHandlers from "./useEntityClickHandlers";

interface Props {
  deal: Deal;
  onCompanyClick?: (companyId: Company["id"]) => void;
  onPersonClick?: (personId: Person["id"]) => void;
}

const DealName: React.FC<Props> = ({ deal, onCompanyClick, onPersonClick }) => {
  const intl = useIntl();

  const [handleCompanyClick, handlePersonClick] = useEntityClickHandlers(
    deal,
    onCompanyClick,
    onPersonClick
  );

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faHandshake} />
      </div>
      <div className={styles.details}>
        <span className={styles.name}>
          {deal.name && deal.name.trim().length ? (
            deal.name
          ) : (
            <i>
              {intl.formatMessage({
                id: "deal.name",
                defaultMessage: "Untitled",
                description: "Deal name value when there's no name",
              })}
            </i>
          )}
        </span>
        <div className={styles.associatedEntityLink}>
          {deal.account && (
            <EntityLink entityId={deal.account.id} entityType={EntityType.COMPANY} legacy={false}>
              <span onClick={handleCompanyClick}>{deal.account.name}</span>
            </EntityLink>
          )}
          {!deal.account && deal.contact && (
            <EntityLink entityId={deal.contact.id} entityType={EntityType.PERSON} legacy={false}>
              <span onClick={handlePersonClick}>{deal.contact.name}</span>
            </EntityLink>
          )}
        </div>
      </div>
    </div>
  );
};

export default DealName;
